import React from 'react'
import Box from '@material-ui/core/Box'
import { Link } from 'react-router-dom'
import { isEmpty } from 'lodash'
import { useFormContext } from 'react-hook-form'
import Facilities from 'components/coaches-profile/profile-components/facilities'
import TipWell, { TipWellActionButton } from 'components/tip-well'
import InfoOutlinedIcon from 'components/material-symbol/icons/Info'
import SaveDialog from 'components/coaches-profile/profile-components/dialog'
import { useCreateProfileFieldStyles } from '../field-styles'

const MANAGE_FACILITIES_PATH = '/pga-coach/settings/facilities'

const EditFacilitiesSection = ({ formFields, onSubmit }) => {
  const fieldClasses = useCreateProfileFieldStyles()
  const { formState, handleSubmit } = useFormContext()
  const { touched } = formState
  const hasUnsavedChanges = !isEmpty(touched)

  const manageFacilitiesButton = (
    <TipWellActionButton
      component={hasUnsavedChanges ? undefined : Link}
      to={hasUnsavedChanges ? undefined : MANAGE_FACILITIES_PATH}
    >
      Manage Facilities
    </TipWellActionButton>
  )

  return (
    <Box className={fieldClasses.fieldSection}>
      <TipWell
        icon={InfoOutlinedIcon}
        caption="These facilities are view-only here. Your primary facility is used for location-based searches on pga.com."
        action={
          hasUnsavedChanges ? (
            <SaveDialog
              trigger={manageFacilitiesButton}
              handleSubmit={handleSubmit(onSubmit)}
            />
          ) : (
            manageFacilitiesButton
          )
        }
      />
      <Facilities formFields={formFields} />
    </Box>
  )
}

export default EditFacilitiesSection
